export const AREAS = [
  { slug: "golden-mile", name: "Golden Mile" },
  { slug: "puerto-banus", name: "Puerto Banus" },
  { slug: "nueva-andalucia", name: "Nueva Andalucia" },
  { slug: "san-pedro", name: "San Pedro" },
  { slug: "benahavis", name: "Benahavis" },
  { slug: "estepona", name: "Estepona" },
  { slug: "marbella-centre", name: "Marbella Centre" },
];

export const FEATURES = [
  { key: "pool", label: "Private Pool" },
  { key: "heated_pool", label: "Heated Pool" },
  { key: "sea_view", label: "Sea View" },
  { key: "beachfront", label: "Beachfront" },
  { key: "jacuzzi", label: "Jacuzzi" },
  { key: "gym", label: "Gym" },
  { key: "sauna", label: "Sauna" },
  { key: "cinema_room", label: "Cinema Room" },
  { key: "smart_home", label: "Smart Home" },
  { key: "golf", label: "Golf" },
  { key: "pet_friendly", label: "Pet Friendly" },
  { key: "family_friendly", label: "Family Friendly" },
  { key: "event_friendly", label: "Event Friendly" },
];

export const FEATURE_LABELS = FEATURES.reduce((acc, f) => ({ ...acc, [f.key]: f.label }), {});

export const COLLECTIONS = [
  { slug: "luxury-villas-marbella", name: "Luxury Villas Marbella" },
  { slug: "beachfront-villas-marbella", name: "Beachfront Villas" },
  { slug: "sea-view-villas-marbella", name: "Sea View Villas" },
  { slug: "villas-with-pool-marbella", name: "Villas With Pool" },
  { slug: "villas-with-heated-pool-marbella", name: "Heated Pool Villas" },
  { slug: "family-villas-marbella", name: "Family Villas" },
  { slug: "golf-villas-marbella", name: "Golf Villas" },
  { slug: "pet-friendly-villas-marbella", name: "Pet Friendly Villas" },
];

export const fmtPrice = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

/**
 * Downscale external stock images (Unsplash / Pexels) to the size they are
 * actually displayed at. Many stored URLs request 1920px (~800KB) for tiles
 * shown at ~300-600px — this caps width/quality so pages load far lighter.
 * Self-hosted / unknown URLs are returned untouched.
 */
export const sizedImg = (url, w = 800, q = 70) => {
  if (!url || typeof url !== "string") return url;
  if (url.includes("images.unsplash.com")) {
    return `${url.split("?")[0]}?auto=format&fit=crop&w=${w}&q=${q}`;
  }
  if (url.includes("images.pexels.com")) {
    return `${url.split("?")[0]}?auto=compress&cs=tinysrgb&w=${w}`;
  }
  return url;
};

